import { render } from "./EvidenciaPago.vue?vue&type=template&id=6730e050"
import script from "./EvidenciaPago.vue?vue&type=script&lang=js"
export * from "./EvidenciaPago.vue?vue&type=script&lang=js"

import "./EvidenciaPago.vue?vue&type=style&index=0&id=6730e050&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__